module.exports = __webpack_public_path__ + "static/media/Breadcrumb_Icon.9b0b688d.svg";